import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { map, take, takeUntil, distinctUntilChanged, filter } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@angular/forms';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@ngrx/store';
import { select } from '@ngrx/store';
import { getDataSourceCountryList, SetDataSourceCountryList, getStepDetails } from 'visa-store';
import * as i2 from 'reference-library';
import * as i5 from '@angular/router';
import * as i6 from 'app-services-library';
import * as i7 from '@angular/common';
import * as i8 from 'primeng/multiselect';
import { PrimengLibraryModule } from 'primeng-library';

class CustomDropdownService {
    constructor(http) {
        this.http = http;
        this.formValues = {};
        this.clientId = new Subject();
        this.projectId = new BehaviorSubject(null);
        this.employeeId = new BehaviorSubject(null);
        this.emails = new BehaviorSubject(null);
        this.refDataSources = {};
        this.emailsChanged = false;
        this.previousEmails = [];
    }
    sendClientId(id) {
        this.clientId.next({ clientId: id });
    }
    getClientId() {
        return this.clientId.asObservable();
    }
    setFormValue(formControlName, value) {
        this.formValues[formControlName] = value;
    }
    getFormValue(formControlName) {
        return this.formValues[formControlName];
    }
    sendProjectId(projectId) {
        this.projectId.next(projectId);
    }
    getProjectId() {
        return this.projectId.asObservable();
    }
    sendEmployeeId(employeeId) {
        this.employeeId.next(employeeId);
    }
    getEmployeeId() {
        return this.employeeId.asObservable();
    }
    /* create-invoice specific-methods */
    sendEmails(emails) {
        this.emails.next(emails);
    }
    getEmails() {
        return this.emails.asObservable();
    }
    setEmailsChanged(value) {
        this.emailsChanged = value;
    }
    getEmailsChanged() {
        return this.emailsChanged;
    }
    setPreviousEmails(emails) {
        this.previousEmails = emails.slice();
    }
    getPreviousEmails() {
        return this.previousEmails.slice();
    }
    /* end of create-invoice specific-methods */
    clearFormValue(formControlName) {
        delete this.formValues[formControlName];
    }
    setRefDataSource(formControlName, refDataArr) {
        this.refDataSources[formControlName] = refDataArr;
    }
    getRefDataSource(formControlName) {
        return this.refDataSources[formControlName];
    }
    getLCANotesByLcaCode(lcaCode) {
        return this.http.get(`/dashboard/petitioner/lca/notes/${lcaCode}`).pipe(map((response) => {
            if (response && (response.status === 200 || response.status === 204)) {
                return response;
            }
        }));
    }
    savenotes(taskId, payload) {
        return this.http.post(`/L1/task/${taskId}/note/create`, payload).pipe(map((response) => {
            // this.updateNotesSubject.next({
            //   notesAdded: payload.noteDetails,
            //   notesAvailable: true,
            //   taskStepId: payload.taskStepId
            // });
            return response;
        }));
    }
}
CustomDropdownService.ɵfac = function CustomDropdownService_Factory(t) { return new (t || CustomDropdownService)(i0.ɵɵinject(i1.HttpClient)); };
CustomDropdownService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomDropdownService, factory: CustomDropdownService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomDropdownService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function CustomDropdownComponent_div_0_div_1_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_1_div_5_option_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r11 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r11.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r11.name);
} }
function CustomDropdownComponent_div_0_div_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "select", 10);
    i0.ɵɵlistener("change", function CustomDropdownComponent_div_0_div_1_div_5_Template_select_change_1_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(3); return ctx_r12.handleDropDownChange($event.target.value, "refDataArr", ctx_r12.formControlName); });
    i0.ɵɵtemplate(2, CustomDropdownComponent_div_0_div_1_div_5_option_2_Template, 2, 2, "option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r6.formControlName);
    i0.ɵɵattribute("name", ctx_r6.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r6.refDataArr);
} }
function CustomDropdownComponent_div_0_div_1_ng_template_6_option_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r15 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r15.code);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", item_r15.name, " -- ", item_r15.description, "");
} }
function CustomDropdownComponent_div_0_div_1_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "select", 10);
    i0.ɵɵlistener("change", function CustomDropdownComponent_div_0_div_1_ng_template_6_Template_select_change_0_listener($event) { i0.ɵɵrestoreView(_r17); const ctx_r16 = i0.ɵɵnextContext(3); return ctx_r16.handleDropDownChange($event.target.value, "refDataArr", ctx_r16.formControlName); });
    i0.ɵɵtemplate(1, CustomDropdownComponent_div_0_div_1_ng_template_6_option_1_Template, 2, 3, "option", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("formControlName", ctx_r8.formControlName);
    i0.ɵɵattribute("name", ctx_r8.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r8.refDataArr);
} }
function CustomDropdownComponent_div_0_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomDropdownComponent_div_0_div_1_em_4_Template, 2, 0, "em", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, CustomDropdownComponent_div_0_div_1_div_5_Template, 3, 3, "div", 6);
    i0.ɵɵtemplate(6, CustomDropdownComponent_div_0_div_1_ng_template_6_Template, 2, 3, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵtemplate(8, CustomDropdownComponent_div_0_div_1_span_8_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r7 = i0.ɵɵreference(7);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.inputParams == null ? null : ctx_r1.inputParams.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.inputParams.properties.refercenceCodeForApiCall !== "FB_HIRING_MDS_LISTOF_JOBIDS")("ngIfElse", _r7);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", (ctx_r1.inputParams == null ? null : ctx_r1.inputParams.mandatory) && ctx_r1.childGroup.get(ctx_r1.formControlName).touched && !ctx_r1.hasValue);
} }
function CustomDropdownComponent_div_0_div_2_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_2_option_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r21 = ctx.$implicit;
    i0.ɵɵproperty("value", item_r21);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(item_r21);
} }
function CustomDropdownComponent_div_0_div_2_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomDropdownComponent_div_0_div_2_em_4_Template, 2, 0, "em", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "select", 14);
    i0.ɵɵlistener("change", function CustomDropdownComponent_div_0_div_2_Template_select_change_5_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.handleDropDownChange($event.target.value, "", ctx_r22.formControlName); });
    i0.ɵɵtemplate(6, CustomDropdownComponent_div_0_div_2_option_6_Template, 2, 2, "option", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, CustomDropdownComponent_div_0_div_2_span_7_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r2.inputParams == null ? null : ctx_r2.inputParams.label, " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.inputParams == null ? null : ctx_r2.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControlName", ctx_r2.formControlName);
    i0.ɵɵattribute("name", ctx_r2.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r2.inputParams.properties.inputArray);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r2.inputParams == null ? null : ctx_r2.inputParams.mandatory) && ctx_r2.childGroup.get(ctx_r2.formControlName).touched && !ctx_r2.hasValue);
} }
function CustomDropdownComponent_div_0_div_3_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_3_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { width: a0 }; };
function CustomDropdownComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomDropdownComponent_div_0_div_3_em_4_Template, 2, 0, "em", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-multiSelect", 15);
    i0.ɵɵlistener("onChange", function CustomDropdownComponent_div_0_div_3_Template_p_multiSelect_onChange_5_listener($event) { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); return ctx_r26.multiSelectAction($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CustomDropdownComponent_div_0_div_3_span_6_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.inputParams == null ? null : ctx_r3.inputParams.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.inputParams == null ? null : ctx_r3.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(10, _c0, ctx_r3.inputParams.style.width));
    i0.ɵɵproperty("ngStyle", ctx_r3.inputParams.style)("options", ctx_r3.refDataArr)("formControlName", ctx_r3.formControlName)("showToggleAll", (ctx_r3.inputParams == null ? null : ctx_r3.inputParams.properties == null ? null : ctx_r3.inputParams.properties.disableSelectAll) ? false : true);
    i0.ɵɵattribute("name", ctx_r3.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r3.inputParams == null ? null : ctx_r3.inputParams.mandatory) && ctx_r3.childGroup.get(ctx_r3.formControlName).touched && !ctx_r3.hasValue);
} }
function CustomDropdownComponent_div_0_div_4_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 9);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_4_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
function CustomDropdownComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelementStart(2, "span", 4);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, CustomDropdownComponent_div_0_div_4_em_4_Template, 2, 0, "em", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p-multiSelect", 16);
    i0.ɵɵlistener("onChange", function CustomDropdownComponent_div_0_div_4_Template_p_multiSelect_onChange_5_listener($event) { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.multiSelectAction($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, CustomDropdownComponent_div_0_div_4_span_6_Template, 2, 0, "span", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r4.inputParams == null ? null : ctx_r4.inputParams.label);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.inputParams == null ? null : ctx_r4.inputParams.mandatory);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(9, _c0, ctx_r4.inputParams.style.width));
    i0.ɵɵproperty("options", ctx_r4.inputParams.properties.inputArray)("formControlName", ctx_r4.formControlName)("showToggleAll", (ctx_r4.inputParams == null ? null : ctx_r4.inputParams.properties == null ? null : ctx_r4.inputParams.properties.disableSelectAll) ? false : true);
    i0.ɵɵattribute("name", ctx_r4.formControlName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r4.inputParams == null ? null : ctx_r4.inputParams.mandatory) && ctx_r4.childGroup.get(ctx_r4.formControlName).touched && !ctx_r4.hasValue);
} }
const _c1 = function (a0) { return { "width": a0 }; };
function CustomDropdownComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, CustomDropdownComponent_div_0_div_1_Template, 9, 5, "div", 2);
    i0.ɵɵtemplate(2, CustomDropdownComponent_div_0_div_2_Template, 8, 6, "div", 2);
    i0.ɵɵtemplate(3, CustomDropdownComponent_div_0_div_3_Template, 7, 12, "div", 2);
    i0.ɵɵtemplate(4, CustomDropdownComponent_div_0_div_4_Template, 7, 11, "div", 2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(7, _c1, ctx_r0.inputParams == null ? null : ctx_r0.inputParams.style == null ? null : ctx_r0.inputParams.style.width));
    i0.ɵɵproperty("formGroup", ctx_r0.childGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.inputParams.properties.isMultiselect && (ctx_r0.refDataArr == null ? null : ctx_r0.refDataArr.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.inputParams.properties.isMultiselect && (ctx_r0.inputParams.properties.inputArray == null ? null : ctx_r0.inputParams.properties.inputArray.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.inputParams.properties.isMultiselect && (ctx_r0.refDataArr == null ? null : ctx_r0.refDataArr.length) > 0);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.inputParams.properties.isMultiselect && ctx_r0.inputParams.properties.inputArray && ctx_r0.inputParams.properties.inputArray.length > 0);
} }
class CustomDropdownComponent {
    constructor(fb, referenceLibraryService, store, customDropdownService, route, cdr, appServicesLibraryService) {
        this.fb = fb;
        this.referenceLibraryService = referenceLibraryService;
        this.store = store;
        this.customDropdownService = customDropdownService;
        this.route = route;
        this.cdr = cdr;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.refDataArr = [];
    }
    ngOnInit() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        this.userType = sessionStorage.getItem('userTypeRole');
        //const dropDownValidators = this.inputParams.mandatory ? [Validators.required] : [];
        /**
        **  For dropdowns added after check property is added it will evaluate to true/false,
        **  for old dropdowns it will be null which will set the data as working previously.
        */
        const setValueOnLoad = (_b = (_a = this.inputParams.properties) === null || _a === void 0 ? void 0 : _a.setValueOnLoad) !== null && _b !== void 0 ? _b : true;
        const value = setValueOnLoad ? (_c = this.inputParams.value) !== null && _c !== void 0 ? _c : null : null;
        this.group.addControl(this.inputParams.name, this.fb.control(value, [this.requiredValidator.bind(this)]));
        if (this.inputParams && this.inputParams.properties && this.inputParams.properties.isDataFromApi && this.inputParams.properties.refercenceCodeForApiCall != '' && !((_d = this.inputParams.properties) === null || _d === void 0 ? void 0 : _d.dependency)) {
            if (value && typeof value === 'object' && value.hasOwnProperty('code')) {
                this.childGroup = new FormGroup({
                    [this.formControlName]: new FormControl(value.code, [this.requiredValidator.bind(this)])
                });
            }
            else {
                this.childGroup = new FormGroup({
                    [this.formControlName]: new FormControl(value, [this.requiredValidator.bind(this)])
                });
            }
            if (this.inputParams.properties.refercenceCodeForApiCall === 'COUNTRY') {
                this.store.pipe(select(getDataSourceCountryList))
                    .pipe(take(1))
                    .subscribe((data) => {
                    if (data && data.length > 0) {
                        this.refDataArr = data;
                    }
                    else {
                        this.referenceLibraryService.getDataSource('COUNTRY', '')
                            .pipe(take(1))
                            .subscribe((response) => {
                            this.refDataArr = response || [];
                            this.store.dispatch(new SetDataSourceCountryList(response || null));
                        });
                    }
                });
            }
            else {
                this.referenceLibraryService
                    .getDataSource(this.inputParams.properties.refercenceCodeForApiCall, '')
                    .pipe(takeUntil(this.observableSubscription$))
                    .subscribe((response) => {
                    this.refDataArr = response || [];
                    this.route.queryParams.subscribe(params => {
                        const stepParameter = params['step'];
                        if (!stepParameter) {
                            this.customDropdownService.clearFormValue(this.formControlName);
                        }
                        else {
                            const savedValue = this.customDropdownService.getFormValue(this.formControlName);
                            const formControl = this.childGroup.get(this.formControlName);
                            if (savedValue && formControl) {
                                formControl.patchValue(savedValue);
                            }
                        }
                    });
                });
            }
        }
        else {
            this.childGroup = new FormGroup({
                [this.formControlName]: new FormControl(value, [this.requiredValidator.bind(this)])
            });
            this.savedRefData = this.customDropdownService.getRefDataSource(this.formControlName);
            this.route.queryParams.subscribe(params => {
                const stepParameter = params['step'];
                if (!stepParameter) {
                    this.customDropdownService.clearFormValue(this.formControlName);
                    this.refDataArr = [];
                }
                else {
                    this.refDataArr = this.savedRefData;
                    const savedValue = this.customDropdownService.getFormValue(this.formControlName);
                    const formControl = this.childGroup.get(this.formControlName);
                    if (savedValue && formControl) {
                        formControl.patchValue(savedValue);
                    }
                }
            });
        }
        if (this.refDataArr && this.refDataArr.length > 0) {
            this.referenceLibraryService.translateArray(this.refDataArr, 'name')
                .then(translated => {
                this.refDataArr = translated;
            })
                .catch(error => console.error("Translation error:", error));
        }
        if (this.inputData) {
            //this.toggleInputFields();
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                var _a;
                this.inputData.stepStatusCode = (_a = data === null || data === void 0 ? void 0 : data.stepStatusDetails) === null || _a === void 0 ? void 0 : _a.stepStatusCode;
                //this.toggleInputFields();
            });
        }
        const dependencyControlName = (_e = this.inputParams.properties) === null || _e === void 0 ? void 0 : _e.dependency;
        if (dependencyControlName && this.group.get(dependencyControlName)) {
            this.group.get(dependencyControlName).valueChanges
                .pipe(distinctUntilChanged(), filter(value => !!value))
                .subscribe(dependencyValue => {
                this.postDependencyValueChange(dependencyValue);
            });
            const isButtonNew = sessionStorage.getItem('isButtonNew') === 'true';
            if (((_f = this.group.get(dependencyControlName)) === null || _f === void 0 ? void 0 : _f.value) && !isButtonNew) {
                this.postDependencyValueChange(this.group.get(dependencyControlName).value, true);
            }
        }
        (_g = this.childGroup.get(this.formControlName)) === null || _g === void 0 ? void 0 : _g.valueChanges.pipe(map(value => !!value)).subscribe(hasValue => {
            this.hasValue = hasValue;
        });
        this.group.valueChanges.subscribe(() => {
            this.cdr.detectChanges();
        });
        if (((_h = this.inputParams.properties) === null || _h === void 0 ? void 0 : _h.isMultiselect) === true && this.inputParams.value.length > 0) {
            this.group.get([this.formControlName]).markAsPristine();
            this.group.get([this.formControlName]).clearValidators();
            this.group.get([this.formControlName]).updateValueAndValidity();
        }
        // this.group.markAsDirty();
        // this.group.updateValueAndValidity();
        // this.group.markAsPristine();
    }
    postDependencyValueChange(dependencyValue, onLoadEdit = false) {
        const isValidObject = typeof dependencyValue === 'object' && dependencyValue !== null && !Array.isArray(dependencyValue) && 'code' in dependencyValue;
        const isNonEmptyArray = Array.isArray(dependencyValue) && dependencyValue.length > 0;
        if (isValidObject || isNonEmptyArray) {
            this.referenceLibraryService
                .getDataSource(this.inputParams.properties.refercenceCodeForApiCall, dependencyValue.code)
                .pipe(take(1))
                .subscribe((response) => {
                var _a, _b, _c;
                this.customDropdownService.setRefDataSource(this.formControlName, response);
                const placeholderOption = {
                    id: 0,
                    desc: '',
                    group: '',
                    code: '',
                    name: 'Please Select'
                };
                const updatedOptions = response ? [placeholderOption, ...response] : [placeholderOption];
                this.refDataArr = updatedOptions;
                this.customDropdownService.setRefDataSource(this.formControlName, this.refDataArr);
                // this.refDataArr = response || [];
                this.childGroup.get(this.formControlName).setValue('');
                this.childGroup.get(this.formControlName).markAsUntouched();
                if (onLoadEdit) {
                    const setValueOnLoad = (_b = (_a = this.inputParams.properties) === null || _a === void 0 ? void 0 : _a.setValueOnLoad) !== null && _b !== void 0 ? _b : true;
                    const value = setValueOnLoad ? (_c = this.inputParams.value) !== null && _c !== void 0 ? _c : null : null;
                    if (value && typeof value === 'object' && value.hasOwnProperty('code')) {
                        this.childGroup = new FormGroup({
                            [this.formControlName]: new FormControl(value.code, [this.requiredValidator.bind(this)])
                        });
                    }
                }
            });
        }
    }
    requiredValidator(control) {
        const currentValue = control.value;
        if (Array.isArray(currentValue) && this.inputParams.mandatory === true) {
            return { 'required': true };
        }
        return null;
    }
    /*   toggleInputFields() {
        if (this.appServicesLibraryService.fieldToBeDisabled(this.inputData.stepStatusCode)) {
          this.childGroup.disable();
        } else {
          this.childGroup.enable();
        }
      } */
    handleDropDownChange(code, arrayName, controlname) {
        if (controlname == 'client') {
            this.customDropdownService.sendClientId(code);
        }
        if (controlname == 'project') {
            this.customDropdownService.sendProjectId(code);
        }
        if (controlname == 'employeeId') {
            this.customDropdownService.sendEmployeeId(code);
        }
        this.group.markAsDirty();
        this.customDropdownService.setFormValue(this.formControlName, code);
        this.group.get([this.formControlName]).patchValue(arrayName === 'refDataArr' ? this.refDataArr.find(x => x.code === code) : code);
        if (this.inputParams.name === 'DROPDOWN_approvedLCAList') {
            const splitted = code.split(" -- ");
            this.getLCANotes(splitted[0]);
        }
    }
    multiSelectAction(data) {
        this.group.get([this.formControlName]).markAsDirty();
        this.group.get([this.formControlName]).patchValue(data.value);
        this.customDropdownService.setFormValue(this.formControlName, data.value);
        if (this.group.get([this.formControlName]).value.length > 0) {
            this.group.get([this.formControlName]).markAsPristine();
            this.group.get([this.formControlName]).clearValidators();
            this.group.get([this.formControlName]).updateValueAndValidity();
        }
        else {
            this.group.get([this.formControlName]).setValidators([Validators.required]);
            this.group.get([this.formControlName]).updateValueAndValidity();
        }
    }
    getLCANotes(lcaCode) {
        this.customDropdownService.getLCANotesByLcaCode(lcaCode)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.saveNotes(response.data.notes);
            }
        });
    }
    saveNotes(notes) {
        const payload = {
            companyId: (this.userType === 'Petitioner') ? this.inputData.companyId : this.inputData.attorneyId,
            noteDetails: notes,
            noteTitle: '',
            taskStepId: this.inputData.stepId
        };
        this.customDropdownService.savenotes(this.inputData.taskId, payload).subscribe((response) => {
            if ((response === null || response === void 0 ? void 0 : response.status) === 200) {
                //console.log("response on notes save",response);        
            }
        });
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
CustomDropdownComponent.ɵfac = function CustomDropdownComponent_Factory(t) { return new (t || CustomDropdownComponent)(i0.ɵɵdirectiveInject(i1$1.FormBuilder), i0.ɵɵdirectiveInject(i2.ReferenceLibraryService), i0.ɵɵdirectiveInject(i3.Store), i0.ɵɵdirectiveInject(CustomDropdownService), i0.ɵɵdirectiveInject(i5.ActivatedRoute), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i6.AppServicesLibraryService)); };
CustomDropdownComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomDropdownComponent, selectors: [["custom-dropdown"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group", inputData: "inputData" }, decls: 1, vars: 1, consts: [[3, "formGroup", "style", 4, "ngIf"], [3, "formGroup"], [4, "ngIf"], [1, "label-cls", "vd-heading-container", "pb-0"], [1, "common-bene-class-for-translation"], ["class", "error", 4, "ngIf"], [4, "ngIf", "ngIfElse"], ["idWithName", ""], ["class", "error common-bene-class-for-translation", 4, "ngIf"], [1, "error"], [1, "form-control", "fixed-width", "dd-select", 3, "formControlName", "change"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "error", "common-bene-class-for-translation"], [1, "form-control", "fixed-width", 3, "formControlName", "change"], ["optionLabel", "name", 1, "remove_border", 3, "ngStyle", "options", "formControlName", "showToggleAll", "onChange"], [3, "options", "formControlName", "showToggleAll", "onChange"]], template: function CustomDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, CustomDropdownComponent_div_0_Template, 5, 9, "div", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.childGroup);
    } }, directives: [i7.NgIf, i1$1.NgControlStatusGroup, i1$1.FormGroupDirective, i1$1.SelectControlValueAccessor, i1$1.NgControlStatus, i1$1.FormControlName, i7.NgForOf, i1$1.NgSelectOption, i1$1.ɵangular_packages_forms_forms_z, i8.MultiSelect, i7.NgStyle], styles: [".vd-edit-icon-style[_ngcontent-%COMP%]{font-size:1rem;color:#01a0da;cursor:pointer;margin-left:21px;margin-top:8px}.form-control[_ngcontent-%COMP%]{height:40px}.error[_ngcontent-%COMP%], .error-indicator[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}.error-indicator[_ngcontent-%COMP%]{position:relative;bottom:62px;left:64px}.dd-select[_ngcontent-%COMP%]{margin-top:4px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'custom-dropdown',
                templateUrl: 'custom-dropdown.component.html',
                styleUrls: ['custom-dropdown.component.scss'
                ]
            }]
    }], function () { return [{ type: i1$1.FormBuilder }, { type: i2.ReferenceLibraryService }, { type: i3.Store }, { type: CustomDropdownService }, { type: i5.ActivatedRoute }, { type: i0.ChangeDetectorRef }, { type: i6.AppServicesLibraryService }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }], inputData: [{
            type: Input
        }] }); })();

class CustomDropdownModule {
}
CustomDropdownModule.ɵfac = function CustomDropdownModule_Factory(t) { return new (t || CustomDropdownModule)(); };
CustomDropdownModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomDropdownModule });
CustomDropdownModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomDropdownModule, { declarations: [CustomDropdownComponent], imports: [PrimengLibraryModule,
        ReactiveFormsModule], exports: [CustomDropdownComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomDropdownModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomDropdownComponent],
                imports: [
                    PrimengLibraryModule,
                    ReactiveFormsModule
                ],
                exports: [CustomDropdownComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-dropdown
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomDropdownComponent, CustomDropdownModule, CustomDropdownService };
//# sourceMappingURL=custom-dropdown.js.map
